export default "__VITE_ASSET__85c565ea__"